import EStyleSheet from 'react-native-extended-stylesheet';

const styles = EStyleSheet.create({
	list: {
		marginBottom: '2rem',
	},
	scrollInner: {
		flexGrow: 1,
	},
});

export default styles;
